/**
 * Sticky occasion pill nav — port of AnlassTags in geschenke/page.tsx:
 * - navVisible = y < 10 || scrolling up (same rule as the navbar)
 * - "stuck" test against the bar's computed sticky top (+1px tolerance)
 * - .is-nav-hidden while the navbar is hidden (top becomes 0)
 * - .is-hidden while hidden AND stuck (translates up by 100% + navbar height)
 * - pill click: smooth scroll to the anchor with the 145px fixed offset
 * - scroll-spy: IO threshold 0.25 over the anchor sections; first
 *   intersecting entry wins (the source's entries.find())
 */
(function () {
  'use strict';

  function initBar(bar) {
    if (bar.dataset.pillsInit) return;
    bar.dataset.pillsInit = '1';

    var pills = Array.prototype.slice.call(bar.querySelectorAll('[data-anchor-target]'));
    if (pills.length === 0) return;

    function setActive(id) {
      pills.forEach(function (pill) {
        pill.classList.toggle('is-active', pill.getAttribute('data-anchor-target') === id);
      });
    }

    var targets = pills
      .map(function (pill) {
        return document.getElementById(pill.getAttribute('data-anchor-target'));
      })
      .filter(Boolean);

    var observer = new IntersectionObserver(
      function (entries) {
        for (var i = 0; i < entries.length; i += 1) {
          if (entries[i].isIntersecting) {
            setActive(entries[i].target.id);
            break;
          }
        }
      },
      { threshold: 0.25 }
    );
    targets.forEach(function (t) {
      observer.observe(t);
    });

    pills.forEach(function (pill) {
      pill.addEventListener('click', function () {
        var el = document.getElementById(pill.getAttribute('data-anchor-target'));
        if (!el) return;
        var top = el.getBoundingClientRect().top + window.scrollY - 145;
        window.scrollTo({ top: top, behavior: 'smooth' });
      });
    });

    window.Dylys.watchScrollDirection(function (state) {
      var navVisible = state.y < 10 || state.up;
      var stickyTop = parseFloat(getComputedStyle(bar).top) || 0;
      var stuck = bar.getBoundingClientRect().top <= stickyTop + 1;
      bar.classList.toggle('is-nav-hidden', !navVisible);
      bar.classList.toggle('is-hidden', !(navVisible || !stuck));
    });
  }

  function initAll(root) {
    (root || document).querySelectorAll('[data-anchor-pills]').forEach(initBar);
  }

  initAll(document);

  document.addEventListener('shopify:section:load', function (e) {
    initAll(e.target);
  });
})();
